import { storableError } from '../../util/errors';

// ================ Action types ================ //

export const SHOW_USER_REQUEST = 'app/PreSignupPage/SHOW_USER_REQUEST';
export const SHOW_USER_SUCCESS = 'app/PreSignupPage/SHOW_USER_SUCCESS';
export const SHOW_USER_ERROR = 'app/PreSignupPage/SHOW_USER_ERROR';

// ================ Reducer ================ //

const initialState = {
  user: null,
  showUserInProgress: false,
  showUserError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SHOW_USER_REQUEST:
      return { ...initialState, showUserInProgress: true };
    case SHOW_USER_SUCCESS:
      return { ...state, showUserInProgress: false, user: payload };
    case SHOW_USER_ERROR:
      return { ...state, showUserInProgress: false, showUserError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const showUserRequest = () => ({ type: SHOW_USER_REQUEST });

export const showUserSuccess = user => ({ type: SHOW_USER_SUCCESS, payload: user });

export const showUserError = e => ({ type: SHOW_USER_ERROR, error: true, payload: e });

// ================ Thunks ================ //

// The user is kept in this page-specific slice as a plain object instead of
// the marketplaceData entity store: the sparse response would replace fuller
// user entities fetched elsewhere (attributes are not deep-merged, see
// combinedResourceObjects in util/data.js).
export const showUser = userId => (dispatch, getState, sdk) => {
  dispatch(showUserRequest());

  return sdk.users
    .show({
      id: userId,
      include: ['profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    })
    .then(response => {
      const user = response.data.data;
      const included = response.data.included || [];
      const imageId = user.relationships?.profileImage?.data?.id?.uuid;
      const profileImage =
        included.find(entity => entity.type === 'image' && entity.id?.uuid === imageId) || null;

      dispatch(showUserSuccess({ ...user, profileImage }));
    })
    .catch(e => dispatch(showUserError(storableError(e))));
};

export const loadData = params => showUser(params.id);
